import React from "react";
import { Modal, Box, Typography, IconButton, Button, SxProps } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  content: string | React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  disableOutsideClick?: boolean;
  confirmDisabled?: boolean;
  sx?: SxProps;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  content,
  onClose,
  onConfirm,
  confirmText = "Confirm",
  disableOutsideClick = false,
  confirmDisabled = false,
  sx = {},
}) => {
  const handleBackdropClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (disableOutsideClick) {
      event.stopPropagation();
    } else {
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={handleBackdropClick}>
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#ffffff",
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          minWidth: 400,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography sx={{ mb: 3 }}>{content}</Typography>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button onClick={onConfirm} color="primary" variant="contained" disabled={confirmDisabled}
            sx={{
              opacity: confirmDisabled ? 0 : 1,
              pointerEvents: confirmDisabled ? "none" : "auto",
            }}
          >
            {confirmText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationDialog;